import { render, staticRenderFns } from "./ChooseMap.vue?vue&type=template&id=5946d227"
import script from "./ChooseMap.vue?vue&type=script&lang=js"
export * from "./ChooseMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports